import Stack from '@mui/material/Stack';
import { DetailsSection } from '../DetailsSection';
import { AttachmentsSection } from '../AttachmentsSection';
import { OverviewAccordion } from './OverviewAccordion';
import { ComponentReports } from '../ComponentReviewPanelReports/ComponentReports';
import { abyssColors } from '@/theme/colors';
import { LocationTag } from '@/constants';

export const ComponentsOverview = () => {
  return (
    <Stack
      id={LocationTag.ReviewPanelComponentOverview}
      spacing={2}
      padding="2.4rem"
      sx={{
        height: '80vh',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: '1.4rem',
        },
        '&::-webkit-scrollbar-track': {
          background: abyssColors.primary[100],
        },
        '&::-webkit-scrollbar-thumb': {
          background: abyssColors.primary[200],
          borderRadius: '1rem',
          height: '0.6rem',
          border: `0.4rem solid ${abyssColors.primary[100]}`,
          cursor: 'grabbing',
        },
      }}
    >
      <>
        <DetailsSection />
        <OverviewAccordion
          title="Attachments"
          details={<AttachmentsSection />}
          defaultExpanded={false}
        />
        <OverviewAccordion
          title="Reports"
          details={<ComponentReports />}
          defaultExpanded={false}
        />
      </>
    </Stack>
  );
};
